// const apiHost = "http://localhost:3001";
const paypalClientId = "AdJ1OyOSaBaHa3tiqnyhmuhVpzPZfw2myJWXCUP4iQeB31zqYT4DSWMy0WUIltSIytXPMSSq7Ut3UDR3";
const paypalClientIdDev = "AfEUx7MpPGew6mqeL3LuutLKgfMrgxS_udKcwSnH5Bg5VUBIx4oFfUMYT2jVzZc4rITZqcI6ph2KoOAp";

const PRODUCTION_BILLING = "https://at.billing.meshplusplus.com";
const STAGING_BILLING = "https://at.staging.billing.meshplusplus.com";
const DEV_BILLING = "https://dev.billing.meshplusplus.com";

// One build serves every environment (mesh-deploy builds once and promotes the
// same files), so the billing API is chosen from the hostname the portal is
// served on instead of being hard-coded per branch. Local development never
// talks to production billing.
function billingApiHost(hostname) {
  const host = String(hostname || "").toLowerCase();
  if (host === "dev.users.meshplusplus.com") return DEV_BILLING;
  if (host.includes("staging")) return STAGING_BILLING;
  if (host === "localhost" || host === "127.0.0.1") return STAGING_BILLING;
  return PRODUCTION_BILLING;
}

const apiHost = billingApiHost(typeof window !== "undefined" ? window.location.hostname : "");

export {
  apiHost,
  billingApiHost,
  paypalClientId,
  paypalClientIdDev,
};
